import { useEffect } from "react";
import { useSeo } from "@/lib/seo";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import Security from "@/components/Security";
import Advantages from "@/components/Advantages";
import Screenshots from "@/components/Screenshots";
import FAQ from "@/components/FAQ";
import Pledge from "@/components/Pledge";
import Savings from "@/components/Savings";

export default function Home() {
    useSeo({
        title: "Coway — Partagez vos trajets en taxi, VTC ou Uber",
        description:
            "Coway vous permet de partager vos trajets en taxi, VTC ou Uber avec des personnes allant dans la même direction. Réduisez vos frais, voyagez malin.",
        canonical: "https://coway.fr/",
    });

    useEffect(() => {
        // Smooth scroll for hash links
        const hash = window.location.hash;
        if (hash) {
            const el = document.querySelector(hash);
            if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
        }
    }, []);

    return (
        <div data-testid="home-page">
            <Hero />
            <HowItWorks />
            <Security />
            <Advantages />
            <Screenshots />
            <Savings />
            <FAQ />
            <Pledge />
        </div>
    );
}
